// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Index_loadingContainer__4Tv8g","spinner":"Index_spinner__2wDnP","spin":"Index_spin__WdR0Y","loadingText":"Index_loadingText__t+XO5","pulse":"Index_pulse__JGM6P"};